import http from '../../../Utils/http';

const UpdateOrganizationDetails = {
  name: 'updateOrganizationDetails',
  state: {
    updating: false,
    errorMessage: '',
    successMessage: '',
  },
  reducers: {
    updateRequested(state) {
      return {
        ...state,
        updating: true,
        errorMessage: '',
        successMessage: '',
      };
    },
    updateSucceeded(state, payload) {
      return {
        ...state,
        updating: false,
        successMessage: payload,
        errorMessage: '',
      };
    },
    updateFailed(state, payload) {
      return {
        ...state,
        updating: false,
        errorMessage: payload,
        successMessage: '',
      };
    },
    clearMessages(state) {
        return {
          ...state,
          errorMessage: '',
          successMessage: '',
        };
      },
  },
  effects: (dispatch) => ({
    async updateOrganizationDetails(updateData) {
      try {
        this.updateRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const response = await http.put(`savvy/organization/organizationDetails/${userInfo.org_id}`, updateData);
        this.updateSucceeded(response.data.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Organization details updated successfully',
            open: true,
          },
        });
      } catch (err) {
        const error = err.response?.data?.error || 'Failed to update organization details';
        this.updateFailed(error);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: error,
            open: true,
          },
        });
      }
    },
    clearUpdateOrganization() {
        this.clearMessages();
      },
  }),
};

export default UpdateOrganizationDetails;
